@import './pn-mainnav-common.scss';
@import '../../../globals/main.scss';

pn-mainnav {
  display: flex;
  flex-flow: row-reverse;
  position: relative;
  width: 100%;
  min-height: 5.1rem;

  @media screen and (min-width: $mobilenav-media-tablet) {
    flex-flow: row;
  }
  @media screen and (min-width: $mobilenav-media-abovemobilemode) {
    flex-flow: column;
  }

  [slot='footer'] {
    @media screen and (min-width: $mobilenav-media-abovemobilemode) {
      display: none;
    }
  }
  > nav {
    height: auto;
    width: 100vw;
    background-color: $white;
    z-index: 2;
    transform: translateX(100vw);
    transition: transform 0.2s 0s;
    transition-property: transform, visibility;
    display: flex;
    flex-flow: column;
    visibility: hidden;
    position: fixed;
    top: 3em;
    bottom: 0;
    left: 0;
    @media screen and (min-width: $mobilenav-media-tablet) {
      top: 6.5em;
    }

    &[data-menu-open='true'] {
      visibility: visible;
      transform: translateX(0);
    }

    @media screen and (min-width: $mobilenav-media-abovemobilemode) {
      flex-flow: row-reverse;
      top: 0;
      position: static;
      // overflow: visible;
      height: auto;
      width: 100%;
      justify-content: space-between;
      visibility: visible;
      transform: translateX(0);
    }

    a {
      text-decoration: none;
    }

    button {
      cursor: pointer;
    }
  }
}

.mainnav-toggle {
  display: flex;
  align-items: center;
  align-self: center;
  // @media screen and (min-width: $mobilenav-media-tablet) {
  //   align-self: center;
  // }
  // @media screen and (min-width: $mobilenav-media-smalldesktop) {
  //   align-self: center;
  // }

  @media screen and (min-width: $mobilenav-media-abovemobilemode) {
    display: none;
  }
  > button {
    display: flex;
    align-items: center;
    background-color: $blue700;
    color: $white;
    border-radius: 2.4rem;
    border: none;
    padding: 0.6rem 1.6rem;
    cursor: pointer;
    font-size: 1.6rem;

    &:focus {
      outline: 0;
    }

    pn-icon {
      margin-left: 0.8rem;
      display: block;
    }

    svg {
      display: block;
      margin: -0.2rem -0.5rem -0.2rem 0;
      height: 1.9rem;
      width: 1.9rem;
    }
  }
}
